"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaceTecApp = void 0;
var verification_copy_1 = require("../../../constants/verification_copy");
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var sampleAppController_1 = require("./../../../../facetec/src/sampleAppController");
var section_swapper_1 = require("../components/section_swapper");
var react_redux_1 = require("react-redux");
var user_1 = require("../../../reducers/slices/user");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_router_dom_1 = require("react-router-dom");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var Config_1 = require("../../../Config");
var main_1 = require("../../../reducers/slices/main");
var FaceTecApp = function () {
    var cookie = new universal_cookie_1.default();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)(cookie.get("user_state")), cookieValue = _a[0], setCookieValue = _a[1];
    var _b = (0, react_1.useState)(false), isFaceTecLoading = _b[0], setIsFaceTecLoading = _b[1];
    // Synchronous latch to prevent the manual button and the polling auto-start from
    // both firing a FaceTec session. React state can't be read synchronously inside the
    // interval closure, so a ref is the only reliable guard across both code paths.
    var hasTriggeredFaceTecRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var checkCookie = function () {
            var _a, _b;
            var userStateCookie = cookie.get("user_state");
            if (JSON.stringify(cookieValue) != JSON.stringify(userStateCookie)) {
                setCookieValue(userStateCookie);
                if (!((_a = user === null || user === void 0 ? void 0 : user.facetec) === null || _a === void 0 ? void 0 : _a.authenticated)) {
                    if ((_b = userStateCookie === null || userStateCookie === void 0 ? void 0 : userStateCookie.facetec) === null || _b === void 0 ? void 0 : _b.authenticated) {
                        setIsFaceTecLoading(false);
                        dispatch((0, user_1.setUser)(userStateCookie));
                        clearInterval(intervalId);
                    }
                }
            }
        };
        // Use an interval to check for changes in the cookie
        var intervalId = setInterval(checkCookie, 5000); // Check every second
        // Cleanup interval on component unmount
        if (user.facetec.authenticated) {
            setIsFaceTecLoading(false);
            clearInterval(intervalId);
        }
    }, [cookieValue, user]);
    // Reset loading state when FaceTec completes (success or failure)
    // Reset loading state on session-token fetch failures
    (0, react_1.useEffect)(function () {
        var originalOnComplete = sampleAppController_1.SampleApp.onComplete;
        sampleAppController_1.SampleApp.onComplete = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setIsFaceTecLoading(false);
            hasTriggeredFaceTecRef.current = false;
            return originalOnComplete.apply(void 0, args);
        };
        var originalOnSessionTokenError = sampleAppController_1.SampleApp.onSessionTokenError;
        sampleAppController_1.SampleApp.onSessionTokenError = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setIsFaceTecLoading(false);
            hasTriggeredFaceTecRef.current = false;
            return originalOnSessionTokenError.apply(void 0, args);
        };
        return function () {
            sampleAppController_1.SampleApp.onComplete = originalOnComplete;
            sampleAppController_1.SampleApp.onSessionTokenError = originalOnSessionTokenError;
        };
    }, []);
    // Safety timeout: reset loading after 60 seconds
    (0, react_1.useEffect)(function () {
        if (!isFaceTecLoading)
            return;
        var timeout = setTimeout(function () {
            setIsFaceTecLoading(false);
            hasTriggeredFaceTecRef.current = false;
        }, 60000);
        return function () { return clearTimeout(timeout); };
    }, [isFaceTecLoading]);
    (0, react_1.useEffect)(function () {
        /**@TODO @Desmond Fix context switch error when the weeb-app tries to redirect automatically */
        var checkFacetec = function () {
            if (user.uid && Config_1.Config.didSucceed) {
                clearInterval(intervalId);
                //   dispatch(setMessageModal(null));
                if (hasTriggeredFaceTecRef.current)
                    return;
                hasTriggeredFaceTecRef.current = true;
                setIsFaceTecLoading(true);
                if (!user.facetecDBRef) {
                    sampleAppController_1.SampleApp.onEnrollUserPressed();
                }
                else if (!user.facetec.authenticated) {
                    sampleAppController_1.SampleApp.onAuthenticateUserPressed();
                }
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Please Wait!",
                    messages: [verification_copy_1.FACIAL_RECOGNITION_INITIALISING],
                }));
            }
        };
        // Use an interval to check for changes in the cookie
        var intervalId = setInterval(checkFacetec, 3000); // Check every second
        return function () { return clearInterval(intervalId); };
    }, [user.uid]);
    (0, react_1.useEffect)(function () {
        if (user.facetecDBRef && user.facetec.authenticated) {
            navigate("/home");
        }
    }, [user]);
    return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
        react_1.default.createElement("div", { className: "flex flex-col items-center gap-4" },
            react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "mt-10" },
                react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "left", image: "", smallTitle: "", bigTitle: verification_copy_1.FACIAL_RECOGNITION_NOTICE_TITLE, 
                    // buttonText="Learn More"
                    description: "To provide you with the highest level of security, our system uses ".concat(verification_copy_1.FACIAL_RECOGNITION, " as an added layer of protection. This involves a face scan to ensure that only you have access to your account."), content: [
                        "First-Time Users: If this is your first time logging in, you will need to complete a simple ".concat(verification_copy_1.FACIAL_RECOGNITION, " enrolment. During this process, you will be guided through a series of steps to securely capture your face. This one-time setup is quick and easy, and it ensures that your future logins are seamless and highly secure."),
                        "Returning Users: If you have already completed ".concat(verification_copy_1.FACIAL_RECOGNITION, " enrolment, you will be asked to perform a face scan at each login. This verification step is crucial for protecting your account from unauthorised access."),
                    ] })),
            !user.facetecDBRef && (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Start Enrollment", backgroundColor: "bg-primary", loading: isFaceTecLoading, enabled: !isFaceTecLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (hasTriggeredFaceTecRef.current)
                            return [2 /*return*/];
                        hasTriggeredFaceTecRef.current = true;
                        setIsFaceTecLoading(true);
                        sampleAppController_1.SampleApp.onEnrollUserPressed();
                        return [2 /*return*/];
                    });
                }); }, size: "xsmall" })),
            user.facetecDBRef && !user.facetec.authenticated && (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Start Authentication", backgroundColor: "bg-primary", loading: isFaceTecLoading, enabled: !isFaceTecLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (hasTriggeredFaceTecRef.current)
                            return [2 /*return*/];
                        hasTriggeredFaceTecRef.current = true;
                        setIsFaceTecLoading(true);
                        sampleAppController_1.SampleApp.onAuthenticateUserPressed();
                        return [2 /*return*/];
                    });
                }); }, size: "xsmall" })),
            user.facetecDBRef && user.facetec.authenticated && (react_1.default.createElement("div", { className: "flex flex-col gap-2 text-green-600 justify-center items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheckCircle, size: "4x" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: verification_copy_1.FACIAL_RECOGNITION_VERIFIED, textColor: "text-green-600", size: "xlarge" }),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Go Home", backgroundColor: "bg-secondary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            navigate("/home");
                            return [2 /*return*/];
                        });
                    }); }, size: "xsmall" }))),
            react_1.default.createElement("p", { id: "status", "aria-live": "polite", className: "hidden" }, "Initializing..."))));
};
exports.FaceTecApp = FaceTecApp;
